var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSoil = function SvgSoil(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M12.5 11s.75-7.512 5.156-7.512c1.72 0 3.094 1.687 3.094 2.425 0 1.192-3.51 3.82-6.735.33M12.5 11s-.75-7.512-5.156-7.512c-1.72 0-3.094 1.687-3.094 2.425 0 1.192 3.51 3.82 6.735.33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.542 15.44q-.541.12-1.083 0a.2.2 0 0 1-.148-.148 2.5 2.5 0 0 1 0-1.084.2.2 0 0 1 .147-.147q.543-.12 1.084 0a.2.2 0 0 1 .148.147q.12.543 0 1.084a.2.2 0 0 1-.148.148M15.292 18.44q-.542.12-1.083 0a.2.2 0 0 1-.148-.148 2.5 2.5 0 0 1 0-1.084.2.2 0 0 1 .148-.147q.541-.12 1.083 0a.2.2 0 0 1 .148.147q.12.543 0 1.084a.2.2 0 0 1-.148.148M13.042 15.44q-.542.12-1.083 0a.2.2 0 0 1-.148-.148 2.5 2.5 0 0 1 0-1.084.2.2 0 0 1 .148-.147q.541-.12 1.083 0a.2.2 0 0 1 .148.147q.12.543 0 1.084a.2.2 0 0 1-.148.148M17.542 15.44q-.541.12-1.084 0a.2.2 0 0 1-.147-.148 2.5 2.5 0 0 1 0-1.084.2.2 0 0 1 .148-.147q.541-.12 1.083 0a.2.2 0 0 1 .148.147q.12.543 0 1.084a.2.2 0 0 1-.148.148M11.167 18.44q-.542.12-1.083 0a.2.2 0 0 1-.148-.148 2.5 2.5 0 0 1 0-1.084.2.2 0 0 1 .148-.147q.541-.12 1.083 0a.2.2 0 0 1 .148.147q.12.543 0 1.084a.2.2 0 0 1-.148.148"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M19.578 20.685a31.2 31.2 0 0 1-14.154.006c-1.596-3.05-1.527-5.847 0-8.877 4.596-1.082 9.558-1.087 14.152-.001 1.565 3.009 1.566 5.863.002 8.872"
  })));
};
export default SvgSoil;